import React from 'react';
import { Segment, Grid, Image } from 'semantic-ui-react';
import birreteImage from '../../assets/img/birrete3.jpeg';
import '../../assets/css/utils.css';

const Welcome = () => (
  <div>
    <Segment placeholder>
      <Grid columns="equal">
        <Grid.Column>
          <Segment attached>
            <Image src={birreteImage} fluid />
          </Segment>
        </Grid.Column>
        <Grid.Column>
          <Segment className="harta-text-justified harta-home-style">
            <p></p>
            Bienvenido a HARTA, la
            <i> Herramienta de Ayuda a la Redacción de Textos Académicos</i>.
            Este entorno de acceso abierto le permitirá usar adecuadamente
            expresiones académicas como <b>colocaciones</b> (
            <i>
              análisis detallado, estudio pormenorizado, corroborar una
              hipótesis
            </i>
            ) y <b>fórmulas</b> (<i>a continuación</i>,
            <i> con el propósito de</i>).
            <p></p>
            HARTA ofrece la posibilidad de realizar consultas directas, bien a
            partir de un nombre como <i>estudio</i> para encontrar sus
            colocaciones, bien a partir de una fórmula como
            <i> en el presente estudio</i> para ver cómo usar esta expresión.
            Asimismo, permite hacer búsquedas según funciones discursivas tales
            como ‘presentar las conclusiones de la investigación’ o ‘hacer
            referencia al propio trabajo’, y facilitar así la tarea de redacción
            de textos en el ámbito investigador. Además, se da acceso a un
            corpus formado por artículos científicos de todos los dominios.
          </Segment>
        </Grid.Column>
      </Grid>
    </Segment>
  </div>
);

export default Welcome;
